import { render, staticRenderFns } from "./VendorOrder.vue?vue&type=template&id=07130210&scoped=true&"
import script from "./VendorOrder.vue?vue&type=script&lang=js&"
export * from "./VendorOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07130210",
  null
  
)

export default component.exports